import { MicRounded, SendOutlined } from '@mui/icons-material';
import { IconButton, Stack } from '@mui/material';
import { CKEditor, ClassicEditor, Form, TextEditorControl } from '@myhrbox/myhrbox-frontend-core';
import { useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputFormInputs, OnInputSubmit } from '../types';

interface InputProps {
  onSubmit: OnInputSubmit;
  disabled: boolean;
}

const Input = ({ onSubmit, disabled }: InputProps) => {
  // TODO: интегрировать, когда сделает бэк
  const microEnabled = false;
  const { t } = useTranslation();
  const form = useForm<InputFormInputs>({
    defaultValues: {
      message: '',
    },
  });
  const { handleSubmit } = form;
  const inputRef = useRef<CKEditor<ClassicEditor>>(null);

  const submitHandler = (formData: InputFormInputs) => {
    onSubmit(formData).then((res) => {
      if (res) form.reset();
    });
  };

  useEffect(() => {
    if (!disabled) {
      // TODO: как-будто не работает сейчас, inputRef.current = null
      inputRef.current?.editor?.focus();
    }
  }, [disabled]);

  return (
    <Form form={form}>
      <Stack
        direction='row'
        alignItems='flex-end'
        spacing={1}
        sx={{
          p: 1,
          border: '1px solid',
          borderColor: 'border',
          borderRadius: 4,
          '& .MuiStack-root': { width: '100%' },
        }}>
        <TextEditorControl
          inputRef={inputRef}
          disabled={disabled}
          name='message'
          // TODO: добавить прокторинг, как-то избавиться от дубль кода с Single.tsx, оптимизировать
          // onReady={handleReady}
          placeholder={t('assessment.question.interview.inputPlaceholder')}
          boxProps={{
            sx: {
              '&.editor-container .ck.ck-editor__main>.ck-editor__editable': {
                minHeight: 140,
                boxShadow: 'none',
                border: 'none',
              },
              '&.editor-container .ck.ck-sticky-panel__content': {
                border: 'none',
              },
            },
          }}
        />
        {microEnabled && (
          <IconButton disabled={disabled}>
            <MicRounded />
          </IconButton>
        )}
        <IconButton onClick={handleSubmit(submitHandler)} disabled={disabled}>
          <SendOutlined sx={{ color: 'primary.main' }} />
        </IconButton>
      </Stack>
    </Form>
  );
};

export default Input;
